// 金额分位及浮点转化
export const moneyFormat = (num, symbo = '') => {
  if (!num) {
    if (num === 0) {
      return symbo + "0.00";
    } else {
      return symbo + "--";
    }
  }
  // 接受数字变双浮点
  let numToFloat = num.toFixed(2);
  // 分割整数和浮点数
  let num0 = numToFloat.split(".")[0];
  let num1 = numToFloat.split(".")[1];
  num0 = parseInt(num0).toLocaleString();
  return symbo + num0 + "." + num1;
};